module.exports = new __parcel__URL__("icon-minus.1c927acc.svg").toString();